import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { countryCodeToEmoji } from "./countries";
import { PlayerAvatar } from "./PlayerAvatar";
import { isPlayerSummary, isRegisteredPlayer, playerSummaryName, } from "./utils";
/**
 * Shared team-page player row: whole row links to the player, showing a
 * nationality flag + name next to the avatar. `leading` fills an optional
 * slot before the avatar (e.g. a squad number); `secondary` renders a compact
 * line beneath the name (e.g. position + Guest); `trailing` fills an optional
 * slot at the end of the row (e.g. match goal/card glyphs). The name truncates
 * with an ellipsis rather than wrapping so the row stays one line tall.
 */
export const PlayerListRow = ({ player, leading, secondary, trailing, showDivider = false, }) => {
    const summary = isPlayerSummary(player);
    const name = playerSummaryName(player);
    // "Real athlete" ring/badge for players with a registered account; guests
    // (external) and summary-only players get a plain avatar.
    const verified = isRegisteredPlayer(player);
    return (_jsx(Link, { to: `/players/${player.id}/`, style: { textDecoration: "none", color: "inherit" }, children: _jsxs(Box, { sx: {
                py: 1,
                px: 2,
                display: "flex",
                alignItems: "center",
                "&:hover": { backgroundColor: "#f8f9ff" },
                transition: "all 0.2s ease",
                borderBottom: showDivider ? "1px solid rgba(0,0,0,0.08)" : "none",
            }, children: [leading, summary ? (_jsx(PlayerAvatar, { playerId: player.id, name: player.name, pictureUrl: player.picture, size: 40, disableLink: true, verified: verified })) : (_jsx(PlayerAvatar, { player: player, size: 40, disableLink: true, verified: verified })), _jsxs(Box, { sx: { ml: 1.5, flex: 1, minWidth: 0 }, children: [_jsxs(Typography, { variant: "body2", noWrap: true, sx: { fontWeight: 600 }, children: [player.nationality
                                    ? `${countryCodeToEmoji(player.nationality)} `
                                    : "", name] }), secondary] }), trailing && _jsx(Box, { sx: { ml: 1, flexShrink: 0 }, children: trailing })] }) }));
};
